import { render, staticRenderFns } from "./equimentVersion.vue?vue&type=template&id=7ca584a2&scoped=true"
import script from "./equimentVersion.vue?vue&type=script&lang=js"
export * from "./equimentVersion.vue?vue&type=script&lang=js"
import style0 from "./equimentVersion.vue?vue&type=style&index=0&id=7ca584a2&lang=scss&scoped=true"
import style1 from "./equimentVersion.vue?vue&type=style&index=1&id=7ca584a2&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca584a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-manage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ca584a2')) {
      api.createRecord('7ca584a2', component.options)
    } else {
      api.reload('7ca584a2', component.options)
    }
    module.hot.accept("./equimentVersion.vue?vue&type=template&id=7ca584a2&scoped=true", function () {
      api.rerender('7ca584a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/equipment/equimentVersion.vue"
export default component.exports